import React, { useContext } from 'react';
import classnames from 'classnames';
import { AppContext } from '../../../../../../AppContext';
import './Comment.scss';

export function Comment({
  comment: {
    id,
    author,
    user_id,
    date,
    content,
    karma: {
      flag,
      likes,
      dislikes
    }
  },
  onKarma,
  onReply
}) {
  const { user } = useContext(AppContext);
  
  function handleKarma(action) {
    onKarma(id, action);
  }

  function handleReply() {
    onReply(id, content);
  }

  return (
    <article className="Comment">
      <header className="Comment__head">
        <b className="Comment__author">{author}</b>
        <time className="Comment__date" dateTime={date}>{date}</time>
      </header>
      <div className="Comment__content">{content}</div>
      <footer className="Comment__foot">
        {user.type !== 'guest' && user_id !== user.user_id && (
          <>
            <button className={classnames('Comment__action-btn', { 'Comment__action-btn_active': flag === 'like' })} onClick={() => handleKarma('like')}>
              <i className="fas fa-thumbs-up" /> {likes ? likes : ''}
            </button>
            <button className={classnames('Comment__action-btn', { 'Comment__action-btn_active': flag === 'dislike' })} onClick={() => handleKarma('dislike')}>
              <i className="fas fa-thumbs-down" /> {dislikes ? dislikes : ''}
            </button>
          </>
        )}
        {user.type !== 'guest' && (
          <button className="Comment__action-btn Comment__action-btn_reply" onClick={handleReply}>
            <i className="fa fa-reply" /> Reply
          </button>
        )}
      </footer>
    </article>
  );
}
